import { addDays, subDays } from 'date-fns'

const date = new Date()

// assignments dates are provided by server as iso8601 strings
const activeStartDate = subDays(date, 2).toISOString()
const activeDueDate = addDays(date, 10).toISOString()

const pendingStartDate = addDays(date, 20).toISOString()
const pendingDueDate = addDays(date, 50).toISOString()

const expiredStartDate = subDays(date, 20).toISOString()
const expiredDueDate = subDays(date, 10).toISOString()

export default [
  // re
  {
    teacher_id: 1,
    start_at: pendingStartDate,
    end_at: pendingDueDate,
    status: 'pending',
    students_completed: 2,
    students_total: 3,
    product: 're',
    precinct: 'lessons',
    assignment_uuid: 'acf24998-a6dc-4c38-a0f9-b98d1a743aef',
    assignment_type: 'book',
    assignedChapters: ['Chapter 1', 'Chapter 2'],
    assignment_details: {
      assignment_id: '1',
    },
    assigner_id: 724179,
    assigned_students: [
      {
        canonical_student_id: 1,
        status: 'completed',
      },
      {
        canonical_student_id: 2,
        status: 'completed',
      },
      {
        canonical_student_id: 3,
        status: 'in-progress',
      },
      {
        canonical_student_id: 5,
        status: 'in-progress',
      },
      {
        canonical_student_id: 6,
        status: 'completed',
      },
    ],
  },
  {
    teacher_id: 1,
    start_at: activeStartDate,
    end_at: activeDueDate,
    status: 'active',
    students_completed: 2,
    students_total: 3,
    product: 're',
    precinct: 'lessons',
    assignment_uuid: 'f6d4db9d-9ce4-474c-b022-b64ad3c79b92',
    assignment_type: 'lesson',
    assignment_details: {
      assignment_id: '4',
    },
    assigner_id: 724179,
    assigned_students: [
      {
        canonical_student_id: 1,
        status: 'completed',
      },
      {
        canonical_student_id: 2,
        status: 'completed',
      },
      {
        canonical_student_id: 3,
        status: 'in-progress',
      },
      {
        canonical_student_id: 5,
        status: 'in-progress',
      },
      {
        canonical_student_id: 6,
        status: 'in-progress',
      },
    ],
  },
  {
    teacher_id: 1,
    start_at: activeStartDate,
    end_at: activeDueDate,
    status: 'active',
    students_completed: 2,
    students_total: 3,
    product: 're',
    precinct: 'driving_tests',
    assignment_uuid: '85d1c152-bacf-4725-a366-fbc0dc6ccad4',
    assignment_type: 'lesson',
    assignment_details: {
      // driving_tests have extra assignment details
      assignment_id: '7',
      category: 'sight_words',
      grade_lesson_number: '4',
      grade_position: '2',
    },
    assigner_id: 724179,
    assigned_students: [
      {
        canonical_student_id: 1,
        status: 'completed',
      },
      {
        canonical_student_id: 2,
        status: 'completed',
      },
      {
        canonical_student_id: 3,
        status: 'in-progress',
      },
      {
        canonical_student_id: 5,
        status: 'in-progress',
      },
      {
        canonical_student_id: 6,
        status: 'in-progress',
      },
    ],
  },

  {
    teacher_id: 1,
    start_at: activeStartDate,
    end_at: activeDueDate,
    status: 'active',
    students_completed: 2,
    students_total: 3,
    product: 're',
    precinct: 'spelling',
    assignment_uuid: '85d1c152-bacf-4725-a366-fbc0dc6ccad4',
    assignment_type: 'spelling',
    assignment_details: {
      // driving_tests have extra assignment details
      description: 'Spelling rules abc 123',
    },
    assigner_id: 724179,
    assigned_students: [
      {
        canonical_student_id: 1,
        status: 'completed',
      },
      {
        canonical_student_id: 2,
        status: 'completed',
      },
      {
        canonical_student_id: 3,
        status: 'in-progress',
      },
      {
        canonical_student_id: 5,
        status: 'in-progress',
      },
      {
        canonical_student_id: 6,
        status: 'in-progress',
      },
    ],
  },
  // Rex
  {
    teacher_id: 1,
    start_at: pendingStartDate,
    end_at: pendingDueDate,
    status: 'pending',
    students_completed: 2,
    students_total: 3,
    product: 'rex',
    precinct: 'english_skills_spelling',
    assignment_uuid: '04f8d009-1b60-495e-af00-e8628fe5d3b7',
    assignment_type: 'lesson',
    assignment_details: {
      assignment_id: '7',
    },
    assigner_id: 724179,
    assigned_students: [
      {
        canonical_student_id: 1,
        status: 'completed',
      },
      {
        canonical_student_id: 2,
        status: 'completed',
      },
      {
        canonical_student_id: 3,
        status: 'in-progress',
      },
      {
        canonical_student_id: 5,
        status: 'in-progress',
      },
      {
        canonical_student_id: 6,
        status: 'in-progress',
      },
    ],
  },
  {
    teacher_id: 1,
    start_at: activeStartDate,
    end_at: activeDueDate,
    status: 'active',
    students_completed: 2,
    students_total: 3,
    product: 'rex',
    precinct: 'my_lessons',
    assignment_uuid: '0bd1036f-00e1-4d52-bc46-58f83a9d7921',
    assignment_type: 'lesson',
    assignment_details: {
      assignment_id: '7',
    },
    assigner_id: 724179,
    assigned_students: [
      {
        canonical_student_id: 1,
        status: 'completed',
      },
      {
        canonical_student_id: 2,
        status: 'completed',
      },
      {
        canonical_student_id: 3,
        status: 'in-progress',
      },
      {
        canonical_student_id: 5,
        status: 'in-progress',
      },
      {
        canonical_student_id: 6,
        status: 'in-progress',
      },
    ],
  },
  {
    teacher_id: 1,
    start_at: activeStartDate,
    end_at: activeDueDate,
    status: 'active',
    students_completed: 3,
    students_total: 5,
    product: 'rex',
    precinct: 'library',
    assignment_uuid: '6b647f69-9ca4-4166-9901-9e6e285f20dd',
    assignment_type: 'read_aloud_chapter',
    assignment_details: {
      assignment_id: 'some-book-code',
      assignment_type: 'read_aloud_chapter',
      chapters: [1],
      classification: 'fiction',
      book_name: 'Some Book Name',
      lexile: '500L',
    },
    assigner_id: 724179,
    assigned_students: [
      {
        canonical_student_id: 1,
        status: 'completed',
      },
      {
        canonical_student_id: 2,
        status: 'completed',
      },
      {
        canonical_student_id: 3,
        status: 'in-progress',
      },
      {
        canonical_student_id: 5,
        status: 'in-progress',
      },
      {
        canonical_student_id: 6,
        status: 'completed',
      },
    ],
  },
  {
    teacher_id: 1,
    start_at: activeStartDate,
    end_at: activeDueDate,
    status: 'active',
    students_completed: 1,
    students_total: 1,
    product: 'rex',
    precinct: 'library',
    assignment_uuid: '23effd24-c338-4121-88ae-90816363a671',
    assignment_type: 'read_aloud_chapter',
    assignment_details: {
      assignment_id: 'some-book-code',
      assignment_type: 'read_aloud_chapter',
      chapters: [1],
      classification: 'fiction',
      book_name: 'Some Book Name',
      lexile: '500L',
    },
    assigner_id: 724179,
    assigned_students: [
      {
        canonical_student_id: 1,
        status: 'completed',
      },
    ],
  },
  // Maths
  {
    start_at: activeStartDate,
    end_at: activeDueDate,
    status: 'active',
    students_completed: 1,
    students_total: 3,
    product: 'maths',
    precinct: 'my_lessons',
    assignment_uuid: 'adc85ba9-deef-4c99-8ec8-23dd8819e0e9',
    assignment_type: 'lesson',
    assignment_details: {
      assignment_id: '7',
    },
    assigner_id: 2,
    assigned_students: [
      {
        canonical_student_id: 1,
        status: 'completed',
      },
      {
        canonical_student_id: 2,
        status: 'in-progress',
      },
      {
        canonical_student_id: 5,
        status: 'in-progress',
      },
    ],
  },
  {
    start_at: pendingStartDate,
    end_at: pendingDueDate,
    status: 'pending',
    students_completed: 0,
    students_total: 4,
    product: 'maths',
    precinct: 'my_lessons',
    assignment_uuid: '4',
    assignment_type: 'lesson',
    assignment_details: {
      assignment_id: '7',
    },
    assigner_id: 2,
    assigned_students: [
      {
        canonical_student_id: 1,
        status: 'pending',
      },
      {
        canonical_student_id: 2,
        status: 'pending',
      },
      {
        canonical_student_id: 3,
        status: 'pending',
      },
      {
        canonical_student_id: 5,
        status: 'pending',
      },
    ],
  },
  {
    start_at: activeStartDate,
    end_at: activeDueDate,
    status: 'completed',
    students_completed: 0,
    students_total: 4,
    product: 'maths',
    precinct: 'my_lessons',
    assignment_uuid: 'fe32915c-47c5-4aed-ad40-6693b66306d6',
    assignment_type: 'lesson',
    assignment_details: {
      assignment_id: '7',
    },
    assigner_id: 2,
    assigned_students: [
      {
        canonical_student_id: 1,
        status: 'completed',
      },
      {
        canonical_student_id: 2,
        status: 'completed',
      },
    ],
  },
  {
    start_at: activeStartDate,
    end_at: activeDueDate,
    status: 'completed',
    students_completed: 0,
    students_total: 4,
    product: 'maths',
    precinct: 'driving_tests',
    assignment_uuid: 'e7844ef3-4cad-4ab4-9174-3541d8fb9c00',
    assignment_type: 'lesson',
    assignment_details: {
      // driving tests have extra assignment details
      assignment_id: '12',
      category: 'measurement',
      grade_lesson_number: '2',
      grade_position: '2',
    },
    assigner_id: 2,
    assigned_students: [
      {
        canonical_student_id: 1,
        status: 'completed',
      },
      {
        canonical_student_id: 2,
        status: 'completed',
      },
    ],
  },
  {
    start_at: expiredStartDate,
    end_at: expiredDueDate,
    status: 'completed',
    students_completed: 3,
    students_total: 3,
    product: 'maths',
    precinct: 'my_lessons',
    assignment_uuid: 'fb56c9ce-2574-41e2-a3af-66038c262de7',
    assignment_type: 'lesson',
    assignment_details: {
      assignment_id: '7',
    },
    assigner_id: 2,
    assigned_students: [
      {
        canonical_student_id: 2,
        status: 'completed',
      },
      {
        canonical_student_id: 3,
        status: 'completed',
      },
      {
        canonical_student_id: 5,
        status: 'completed',
      },
    ],
  },
  {
    start_at: expiredStartDate,
    end_at: expiredDueDate,
    status: 'expired',
    students_completed: 1,
    students_total: 4,
    product: 'maths',
    precinct: 'my_lessons',
    assignment_uuid: '457a57ca-22ac-4f59-bdc8-c6b7744c0c05',
    assignment_type: 'lesson',
    assignment_details: {
      assignment_id: '7',
    },
    assigner_id: 2,
    assigned_students: [
      {
        canonical_student_id: 1,
        status: 'expired',
      },
      {
        canonical_student_id: 2,
        status: 'completed',
      },
      {
        canonical_student_id: 3,
        status: 'expired',
      },
      {
        canonical_student_id: 5,
        status: 'expired',
      },
    ],
  },
  {
    start_at: expiredStartDate,
    end_at: expiredDueDate,
    status: 'expired',
    students_completed: 1,
    students_total: 4,
    product: 'maths',
    precinct: 'driving_tests',
    assignment_uuid: '9f31ac7e-9949-4ff1-ab38-3eabf923c2cd',
    assignment_type: 'lesson',
    assignment_details: {
      // driving tests have extra details
      assignment_id: '34',
      category: 'measurement',
      grade_lesson_number: '14',
      grade_position: '2',
    },
    assigner_id: 2,
    assigned_students: [
      {
        canonical_student_id: 1,
        status: 'expired',
      },
      {
        canonical_student_id: 2,
        status: 'completed',
      },
      {
        canonical_student_id: 3,
        status: 'expired',
      },
      {
        canonical_student_id: 5,
        status: 'expired',
      },
    ],
  },
  // fp
  {
    teacher_id: 1,
    start_at: pendingStartDate,
    end_at: pendingDueDate,
    status: 'pending',
    students_completed: 2,
    students_total: 3,
    product: 'fast_phonics',
    precinct: 'lessons',
    assignment_uuid: 'acf24998-a6dc-4c38-a0f9-b98d1a743addf',
    assignment_type: 'lesson',
    assignment_details: {
      assignment_id: '1',
      description: 'fp_lesson_description_1',
    },
    assigner_id: 724179,
    assigned_students: [
      {
        canonical_student_id: 1,
        status: 'completed',
      },
      {
        canonical_student_id: 2,
        status: 'completed',
      },
      {
        canonical_student_id: 3,
        status: 'in-progress',
      },
      {
        canonical_student_id: 5,
        status: 'in-progress',
      },
      {
        canonical_student_id: 6,
        status: 'completed',
      },
    ],
  },
  {
    teacher_id: 1,
    start_at: activeStartDate,
    end_at: activeDueDate,
    status: 'active',
    students_completed: 2,
    students_total: 3,
    product: 'fast_phonics',
    precinct: 'lessons',
    assignment_uuid: 'f6d4db9d-9ce4-474c-b022-b64ad3c7ab92',
    assignment_type: 'lesson',
    assignment_details: {
      assignment_id: '4',
      description: 'fp_lesson_description_4',
    },
    assigner_id: 724179,
    assigned_students: [
      {
        canonical_student_id: 1,
        status: 'completed',
      },
      {
        canonical_student_id: 2,
        status: 'completed',
      },
      {
        canonical_student_id: 3,
        status: 'in-progress',
      },
      {
        canonical_student_id: 5,
        status: 'in-progress',
      },
      {
        canonical_student_id: 6,
        status: 'in-progress',
      },
    ],
  },
  {
    teacher_id: 1,
    start_at: activeStartDate,
    end_at: activeDueDate,
    status: 'active',
    students_completed: 2,
    students_total: 3,
    product: 'fast_phonics',
    precinct: 'lessons',
    assignment_uuid: '85d1c152-bacf-4725-a366-fbc0dc6ddad4',
    assignment_type: 'lesson',
    assignment_details: {
      assignment_id: '6',
      description: 'fp_lesson_description_6',
    },
    assigner_id: 724179,
    assigned_students: [
      {
        canonical_student_id: 1,
        status: 'completed',
      },
      {
        canonical_student_id: 2,
        status: 'completed',
      },
      {
        canonical_student_id: 3,
        status: 'in-progress',
      },
      {
        canonical_student_id: 5,
        status: 'in-progress',
      },
      {
        canonical_student_id: 6,
        status: 'in-progress',
      },
    ],
  },
  {
    teacher_id: 1,
    start_at: expiredStartDate,
    end_at: expiredDueDate,
    status: 'expired',
    students_completed: 2,
    students_total: 3,
    product: 'fast_phonics',
    precinct: 'lessons',
    assignment_uuid: '85d1c111-bacf-4725-a366-fbc0dc6ddad4',
    assignment_type: 'lesson',
    assignment_details: {
      assignment_id: '11',
      description: 'fp_lesson_description_11',
    },
    assigner_id: 724179,
    assigned_students: [
      {
        canonical_student_id: 1,
        status: 'completed',
      },
      {
        canonical_student_id: 2,
        status: 'completed',
      },
      {
        canonical_student_id: 3,
        status: 'expired',
      },
      {
        canonical_student_id: 5,
        status: 'expired',
      },
      {
        canonical_student_id: 6,
        status: 'expired',
      },
    ],
  },
  {
    assigned_students: [
      {
        canonical_student_id: 1,
        status: 'in-progress',
      },
    ],
    assigner_id: 724179,
    assignment_details: {
      assignment_id: '3',
    },
    assignment_type: 'lesson',
    assignment_uuid: '1',
    end_at: activeDueDate,
    id: '5493c018-563c-41b3-b335-1fdfd51d0a9a',
    name: null,
    precinct: 'lessons',
    product: 'writing_legends',
    start_at: activeStartDate,
    status: 'active',
    students_completed: 0,
    students_total: 1,
    teacher_id: 1,
  },
  {
    assigned_students: [
      {
        canonical_student_id: 2,
        status: 'completed',
      },
      {
        canonical_student_id: 3,
        status: 'completed',
      },
    ],
    assigner_id: 724179,
    assignment_details: {
      assignment_id: '2',
    },
    assignment_type: 'lesson',
    assignment_uuid: '2',
    end_at: expiredDueDate,
    id: '9ca1e523-cd69-4b1a-bb27-417dd4dd52af',
    name: null,
    precinct: 'lessons',
    product: 'writing_legends',
    start_at: expiredStartDate,
    status: 'expired',
    students_completed: 2,
    students_total: 2,
    teacher_id: 1,
  },

  {
    assigned_students: [
      {
        canonical_student_id: 1,
        status: 'completed',
      },
      {
        canonical_student_id: 2,
        status: 'completed',
      },
      {
        canonical_student_id: 3,
        status: 'completed',
      },
    ],
    assigner_id: 724179,
    assignment_details: {
      assignment_id: '8',
    },
    assignment_type: 'lesson',
    assignment_uuid: '3',
    end_at: expiredDueDate,
    id: '9ca1e523-cd69-4b1a-bb27-417dd4dd5201',
    name: null,
    precinct: 'lessons',
    product: 'writing_legends',
    start_at: expiredStartDate,
    status: 'completed',
    students_completed: 3,
    students_total: 3,
    teacher_id: 1,
  },

  {
    assigned_students: [
      {
        canonical_student_id: 1,
        status: 'in-progress',
      },
      {
        canonical_student_id: 2,
        status: 'completed',
      },
    ],
    assigner_id: 724179,
    assignment_details: {
      assignment_id: 'long_ewi_id',
      title: 'The Cat in the Hat',
    },
    assignment_type: 'ewi',
    assignment_uuid: '4',
    end_at: activeDueDate,
    id: '5493c018-563c-41b3-b335-1fdfd51d1234',
    name: null,
    precinct: 'ewi',
    product: 'writing_legends',
    start_at: activeStartDate,
    status: 'pending',
    students_completed: 1,
    students_total: 2,
    teacher_id: 1,
  },

  {
    assigned_students: [
      {
        canonical_student_id: 1,
        status: 'in-progress',
      },
      {
        canonical_student_id: 2,
        status: 'completed',
      },
    ],
    assigner_id: 724179,
    assignment_details: {
      assignment_id: 'cm86wpriv002x5v2y7gfqgl62',
      title: 'Funding the arts',
    },
    assignment_type: 'long-write',
    assignment_uuid: 'cfc5b947-a66e-4dd6-978d-c3573151085e',
    end_at: activeDueDate,
    id: 'cfc5b947-a66e-4dd6-978d-c3573151085e',
    name: null,
    precinct: 'long-writes',
    product: 'writing_legends',
    start_at: activeStartDate,
    status: 'active',
    students_completed: 1,
    students_total: 2,
    teacher_id: 1,
  },
]
